module.exports = __webpack_public_path__ + "7073e64716513720bd0037676eeee22c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/menu_icons/Playlist.png
// module id = 817
// module chunks = 0